import { useQuery } from "@tanstack/react-query";
import { getUsersMeTerminalPin } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

const TERMINAL_PIN_QUERY_KEY = "TERMINAL_PIN";

export const terminalPinKeys = {
  all: [TERMINAL_PIN_QUERY_KEY],
};

export const useTerminalPinQuery = () =>
  useQuery({
    queryKey: terminalPinKeys.all,
    queryFn: processResponseWithApiProblemDetails(() =>
      getUsersMeTerminalPin(),
    ),
  });
